<template>
  <div class="login">
    <div class="img_wrap">
      <img src="../assets/img/logo.png" alt="" class="loginImg" />
    </div>
    <div class="user" v-if="flag">
      <img src="../assets/img/user.png" alt="" class="userImg" />
      <input type="text" class="input" placeholder="请输入用户名" v-model="username" />
    </div>
    <div class="user" v-if="flag1">
      <img src="../assets/img/user.png" alt="" class="userImg" />
      <input type="text" class="input" placeholder="请输入手机号" v-model="mobile" />
    </div>
    <div class="user" style="margin-top: 1.2rem">
      <img src="../assets/img/password.png" alt="" class="userImg " />
      <input type="password" class="input" placeholder="输入密码" v-model="password" />
      <p class="forgetPsw" @click="forgetPsw">忘记密码</p>
    </div>
    <div class="changeMode">
      <i class="el-icon-warning" style="margin-right:3px;margin-top:2px;"></i>
      <span @click="phoneLogin" v-if="flag">手机号登录</span>
      <span @click="phoneLogin1" v-if="flag1">账号登录</span>
    </div>
    <div class="loginButton" @click="onSubmit">登录</div>
    <!-- <div class="loginButton" @click="onReset">重置密码</div> -->
    <!-- <p @click="onReset" class="resetPsw">密码重置</p> -->
    <van-dialog v-model="show" title="标题" show-cancel-button :overlayStyle="overlayStyle"></van-dialog>
  </div>
</template>
<script>
import {
  accountLogin,
} from '@/axios/api'
export default {
  data() {
    return {
      form: {},
      flag: true,
      flag1: false,
      username: '',
      password: '',
      mobile: "",
      show: false,
      overlayStyle: {
        'opacity': '0.3'

      }
    };
  },
  methods: {
    onSubmit() {
      accountLogin({
        userName: this.username,
        password: this.$md5(this.password),
        mobile: this.mobile
      })
        .then((res) => {
          console.log(res.result);
          if (res.result == true) {
            // console.log('0000')
            this.$toast.success('登录成功');
            localStorage.setItem('userInfo', JSON.stringify(res.data))
            localStorage.setItem('token', res.data.token)
            localStorage.setItem('cityCode', res.data.cityCode)
            console.log(res.data.doctorNo);
            this.$router.replace("/system");
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          // this.show = true
          console.log(err)
          // this.$toast.fail(err);
        })
    },
    keyDown(e) {
      // 回车则执行登录方法
      if (e.keyCode === 13) {
        this.onSubmit(); // 定义的登录方法
      }
    },
    forgetPsw() {
      this.$router.push('/forget')
    },
    onReset() {
      this.$router.push('/resetPsw')
    },
    phoneLogin() {
      this.flag = false
      this.flag1 = true
      this.username = ''
    },
    phoneLogin1() {
      this.flag = true
      this.flag1 = false
      this.mobile = ''
    },
  },
  mounted() {
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  }
};

</script>
<style scoped>
.login {
  background-color: #fff;
  height: calc(100vh);
}
.loginImg {
  width: 15rem;
}

.img_wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 0 1rem 0;
  box-sizing: border-box;
}

.loginButton {
  width: 80%;
  margin: 0 auto;
  height: 2.875rem;
  background: linear-gradient(122deg, #17bcc5 0%, #0164a8 100%);
  border-radius: 5rem;
  text-align: center;
  line-height: 3rem;
  font-size: 0.875rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-top: 2rem;
}

.login >>> .van-field__control {
  padding-left: 6rem;
  box-sizing: border-box;
}

.user {
  display: flex;
  align-items: center;
  margin-left: 2.5rem;
  position: relative;
  border-bottom: 1px solid #f1f3f8;
  width: 80%;
}

.userImg {
  width: 1.2rem;
}

.input {
  width: 80%;
  height: 2rem;
  border: none;
  background: #fff;
  display: block;
  float: left;
  outline: none;
  -webkit-appearance: button;
  font-size: 0.875rem;
  margin-left: 1rem;
  padding: 1.7rem 0;
  box-sizing: border-box;
}

.forgetPsw {
  font-size: 0.75rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0364a8;
  position: absolute;
  right: 5%;
  bottom: 0.31rem;
}

.resetPsw {
  cursor: pointer;
  font-size: 0.85rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0364a8;
  text-align: center;
  margin-top: 1rem;
}
.changeMode {
  /* float: right; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #c0c5ca;
  cursor: pointer;
  margin-bottom: 12px;
  font-size: 12px;
  width: 80%;
  margin: 0.5rem auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue